import { buildParams } from '@/helpers/url';

const initialState = {
  categories: [
    {
      value: 0,
      name: 'None',
    },
    {
      value: 1,
      name: 'Soft skill',
    },
    {
      value: 2,
      name: 'Hard skill',
    },
  ],
};

const getters = {
  categoryOptions(state) {
    return state.categories;
  },
};

const actions = {
  async getListCompetencyGroup(_, params) {
    try {
      const queries = buildParams(params);
      const url = `${this._vm.$endPoint}/competencies-groups?${queries}`;
      const { data, response } = await this._vm.$axios.get(url);

      if ((data?.status === 200 || data?.status_code === 200) && data?.data) {
        return data;
      }

      throw response?.data?.message || data?.message || 'Failed to fetch competency group';
    } catch (err) {
      throw Error(err);
    }
  },
  async getListCompetencyItems(_, { params, id }) {
    try {
      let url = `${this._vm.$endPoint}/competencies-groups/competency-items`;

      if (id) url += `/${id}`;

      const { data, response } = await this._vm.$axios.get(url, { params });

      if ((data?.status === 200 || data?.status_code === 200) && data?.data) {
        return data;
      }

      throw response?.data?.message || data?.message || 'Failed to fetch competency group';
    } catch (err) {
      throw Error(err);
    }
  },
  async getDetailCompetencyGroup(_, uuid) {
    try {
      const url = `${this._vm.$endPoint}/competencies-groups/${uuid}`;
      const { data, response } = await this._vm.$axios.get(url);

      if ((data?.status === 200 || data?.status_code === 200) && data?.data) {
        return data;
      }

      throw response?.data?.message || data?.message || 'Failed to fetch detail competency group';
    } catch (err) {
      throw Error(err);
    }
  },
  async updateCompetencyGroup(_, { uuid, payload }) {
    const path = `${this._vm.$endPoint}/competencies-groups/${uuid}/update`;

    try {
      const { data, response } = await this._vm.$axios.post(path, payload);

      if (data?.status === 200) return true;

      throw response?.data?.errors?.error || data?.message || 'Failed to update competency group';
    } catch (err) {
      throw Error(err);
    }
  },
  async createCompetencyGroup(_, payload) {
    const path = `${this._vm.$endPoint}/competencies-groups`;

    try {
      const { data, response } = await this._vm.$axios.post(path, payload);

      if (data?.status === 200) return true;

      throw response?.data?.errors?.error || data?.message || 'Failed to create competency group';
    } catch (err) {
      throw Error(err);
    }
  },
  async deleteCompetency(_, uuid) {
    const path = `${this._vm.$endPoint}/competencies-groups/${uuid}`;

    try {
      const { data, response } = await this._vm.$axios.delete(path);

      if ((data?.status === 200 || data?.status_code === 200) && data?.data) {
        return 'Competency group deleted';
      }

      throw response?.data?.message || data?.message || 'Failed to delete competency group';
    } catch (err) {
      throw Error(err);
    }
  },
};

export default {
  namespaced: true,
  state: () => ({ ...initialState }),
  getters,
  actions,
};
